module.exports = __webpack_public_path__ + "pc/img/banner.ac2eeb96.png";